import { Space } from 'antd';
import styled from 'styled-components';

export const StyledWrapper = styled(Space)`
  height: 100vh;
  width: 100vw;
  justify-content: center;
`;
